import React, { useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

function LoginForm({ onLogin, onSwitchToRegister }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const res = await fetch(`${API_URL}/token/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      });
      if (!res.ok) {
        const data = await res.json();
        if (data?.detail === "No active account found with the given credentials") {
          setError("Неверный логин или пароль");
        } else {
          setError(
            data?.detail ||
            data?.username?.[0] ||
            data?.password?.[0] ||
            "Неверный логин или пароль"
          );
        }
        return;
      }
      const data = await res.json();
      localStorage.setItem('access_token', data.access);
      localStorage.setItem('refresh_token', data.refresh);
      onLogin && onLogin();
    } catch (err) {
      setError('Ошибка сети');
    }
  };

  return (
    <form onSubmit={handleSubmit} style={{ maxWidth: 320, margin: '40px auto', display: 'flex', flexDirection: 'column', gap: 12 }}>
      <input
        type="text"
        placeholder="Логин"
        value={username}
        onChange={e => setUsername(e.target.value)}
        required
        autoFocus
      />
      <input
        type="password"
        placeholder="Пароль"
        value={password}
        onChange={e => setPassword(e.target.value)}
        required
      />
      <button type="submit">Войти</button>
      <button type="button" onClick={onSwitchToRegister} style={{ background: 'none', color: '#2980b9', border: 'none', cursor: 'pointer', marginTop: 4 }}>
        Нет аккаунта? Зарегистрироваться
      </button>
      {error && <div style={{ color: 'red', marginTop: 8 }}>{error}</div>}
    </form>
  );
}

export default LoginForm;
